import React from "react";
import { LOGO_URL } from "../lib/permissions";

export function Logo({ size = 40, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Modav Farms"
      className={`rounded-full bg-white object-cover ${className}`}
      style={{ width: size, height: size, minWidth: size }}
      data-testid="modav-logo"
    />
  );
}
